import styled from "styled-components";

const StyledFooter = styled.footer`
    background-color: #96a99f;
    padding: 30px 10px;
`;

export default StyledFooter;